module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-01-m.a1357155c9e5a8aa40e218c292125e6a.png";